import axios from 'axios';
import getUrl from 'utils/getUrl';
import omitUndefinedProps from 'sharedParts/utils/omitUndefinedProps';
import { generateApiError } from './utils/apiErrorMessages';
import { mapSurveySettingsToApiModel } from './dataMapper/surveySettingsDataMapper';
import settingsSubmissionError from './submissionErrors/settingsSubmissionError';

export default (collectionPath, id, setting = {}) =>
  axios
    .patch(
      getUrl.apiV2(`${collectionPath}/${id}`),
      omitUndefinedProps(mapSurveySettingsToApiModel(setting)),
    )
    .catch(generateApiError({ submissionErrorMap: settingsSubmissionError }));
